import purpleSmLightPng from '/img/light/purple-sm.png';
import purpleSmLightWebp from '/img/light/purple-sm.webp';

export const lightImages = {
  purpleSm: {
    png: purpleSmLightPng,
    webp: purpleSmLightWebp,
  },
};
